<template>
    <iframe
        :src="modalData"
        id="iframe-content"
        :width="iframeWidth"
        :height="iframeHeight"
        style="overflow:hidden; border:none; margin:0; margin-top: 0; "
    />
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import config from '@config';
    import { errorGuard } from '@app/utils';

    export default {
        name: 'DepositResponseModal',
        data() {
            return {
                iframeHeight: config.app.user.deposit.iframeHeight,
                iframeWidth: config.app.user.deposit.iframeWidth,
            };
        },
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
        },
        methods: {
            ...mapActions('ui/user/account', [
                'getBalance',
            ]),
        },
        beforeDestroy() {
            errorGuard({
                action: () => this.getBalance({ showLoading: true })
            });
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/deposit/DepositResponseModal.vue